import { useLocalStorage } from '../useStorage';

export const useFilterShortcut = () => {
  return useLocalStorage<boolean>('confidence-filter-shortcut-enabled', true);
};
